import R from 'ramda';
import { reducerWrapper } from '../support/utils';
import { SAVE_FEEDBACK } from '../actions/FeedbackActions';

export const INIT_STATE = {
  feedback: {}
};

function Handler(state, action) {
  switch (action.type) {
    case SAVE_FEEDBACK.response:
      return R.merge(state, {
        feedback: action.data.feedback
      });

    default:
      return state;
  }
}

const Feedback = reducerWrapper(INIT_STATE, Handler, {
  request: [SAVE_FEEDBACK],
  error: [SAVE_FEEDBACK]
});

export default Feedback;
